// React
import { useEffect } from "react";

// Third party imports
import { useDispatch } from "react-redux";

import {
  setAccess,
  setCompanyId,
  setCompanyIds,
  setIsAuth,
  setOperatorId,
  setRefresh,
  setSubdomain,
  setUserType,
} from "redux/slices/userAuth.jsx";

export function useLoginDataTransfer() {
  // Handle login and logout data transfer if required
  const urlParams = new URLSearchParams(window.location.search);
  // Handle login data transfer
  const encodedData = urlParams.get("data");
  if (encodedData) {
    try {
      const data = JSON.parse(decodeURIComponent(encodedData));
      // Save data in the subdomain's localStorage
      localStorage.setItem("refresh", JSON.stringify(data.refresh));
      localStorage.setItem("access", JSON.stringify(data.access));
      localStorage.setItem("user_type", JSON.stringify(data.user_type));
      localStorage.setItem("operator_id", JSON.stringify(data.operator_id));
      localStorage.setItem("company_id", JSON.stringify(data.company_id ?? null));
      localStorage.setItem("company_ids", JSON.stringify(data.company_ids ?? (data.company_id ? [data.company_id] : [])));
      localStorage.setItem("subdomain", JSON.stringify(data.subdomain));
      localStorage.setItem("is_onboarding_completed", JSON.stringify(data.is_onboarding_completed));
      // Remove data from the query string for security reasons
      window.history.replaceState({}, document.title, window.location.pathname);
    } catch (error) {
      console.error("Failed to decode login data:", error);
      window.location.href = window.location.origin + "/login";
    }
  }
}
export function useInitAuth() {
  const dispatch = useDispatch();
  const access = localStorage.getItem("access");
  const refresh = localStorage.getItem("refresh");
  const userType = localStorage.getItem("user_type");
  const operatorId = localStorage.getItem("operator_id");
  const companyId = localStorage.getItem("company_id");
  const companyIds = localStorage.getItem("company_ids");
  const subdomain = localStorage.getItem("subdomain");
  useEffect(() => {
    if (access) {
      dispatch(setAccess(JSON.parse(access)));
    }
    if (refresh) {
      dispatch(setRefresh(JSON.parse(refresh)));
    }
    if (userType) {
      dispatch(setUserType(JSON.parse(userType)));
    }
    if (operatorId) {
      dispatch(setOperatorId(JSON.parse(operatorId)));
    }
    if (companyId) {
      dispatch(setCompanyId(JSON.parse(companyId)));
    }
    if (companyIds) {
      dispatch(setCompanyIds(JSON.parse(companyIds)));
    }
    if (subdomain) {
      dispatch(setSubdomain(subdomain));
    }
    if (!!access) {
      dispatch(setIsAuth());
    }
  }, [dispatch, access, refresh, userType]);
}
